import type { FC, ReactElement } from "react";
import { type BaseFieldProps, Field, type WrappedFieldProps } from "redux-form";
import { ColorButton } from "widgets";

import { fieldIsInvalid } from "@/app-utils/form.js";
import { FormError } from "@/ui-modules/core/form/layout/FormError.js";
import { FormInputGroup } from "@/ui-modules/core/form/layout/FormGroup.js";
import { FormInputWidget } from "@/ui-modules/core/form/layout/FormInputWidget.js";
import { FormLabel } from "@/ui-modules/core/form/layout/FormLabel.js";

export interface IColorPickerFieldProps extends Partial<WrappedFieldProps> {
  title?: string | ReactElement;
  tooltip?: string;
  horizontalLayout?: boolean;
}

const ColorPickerField: FC<IColorPickerFieldProps> = (props) => {
  return (
    <FormInputGroup horizontalLayout={props.horizontalLayout}>
      {props.title && <FormLabel>{props.title}</FormLabel>}
      <FormInputWidget tooltip={props.tooltip}>
        <ColorButton defaultColor={props.input?.value} onApply={(color) => props.input?.onChange(color)} size="tiny" />
        {fieldIsInvalid(props) && <FormError>{props.meta?.error}</FormError>}
      </FormInputWidget>
    </FormInputGroup>
  );
};
export default ColorPickerField;

export function ColorPickerReduxFormField(props: IColorPickerFieldProps & BaseFieldProps) {
  return <Field {...props} />;
}
